module.exports = __webpack_public_path__ + "7fe8c8441eb3bd14920004beee22d045.fbx";